<template>
  <v-btn
    icon="fas fa-pen-to-square"
    variant="text"
    size="small"
    color="primary"
    @click="goTo(routeName, routeParams, routeQuery)"
  ></v-btn>
</template>

<script>
export default {
  name: "EditBtnComp",

  props: {
    routeName: {
      required: true,
      type: String
    },
    routeParams: {
      required: true,
      type: Object
    },
    routeQuery: {
      default: undefined,
      type: Object
    },
  },
}
</script>
